import React, { useEffect, useMemo, useState } from "react";
import { ArrowUpDown, ChevronDown, ChevronUp } from "lucide-react";
import { Checkbox } from "../../Form/component";
import { ThProps } from "../interfaces";
import { useLocation } from "react-router-dom";

const noop = (): void => undefined;

export const Th: React.FC<ThProps> = ({
  align = "left",
  isCut,
  firstFieldKey,
  hasSorting = false,
  minWidth = 100,
  secondFieldKey,
  sortFunction,
  sortKey,
  title,
  weight = 1,
  sortKeyName,
  isCheckbox = false,
  isChecked = false,
  isDisabled = false,
  onCheckboxChange,
}) => {
  const [orderBy, setOrderBy] = useState<"ASC" | "DESC">("DESC");
  const location = useLocation();

  const handleOrderBy = (): void => {
    const newOrderBy: "ASC" | "DESC" = orderBy === "ASC" ? "DESC" : "ASC";

    setOrderBy(newOrderBy);

    sortFunction?.(usableSortKeyName, newOrderBy);
  };

  useEffect(() => {
    setOrderBy(
      location.search.includes("orderBy=ASC")
        ? "ASC"
        : location.search.includes("orderBy=DESC")
          ? "DESC"
          : "DESC",
    );
  }, []);

  const usableSortKeyName = useMemo(() => {
    if (sortKeyName) {
      return sortKeyName;
    }

    const order: string = sortKey
      ? sortKey === "first"
        ? firstFieldKey ?? ""
        : secondFieldKey ?? firstFieldKey ?? ""
      : firstFieldKey ?? "";

    return order;
  }, [sortKeyName, sortKey, firstFieldKey, secondFieldKey]);

  // Render checkbox header
  if (isCheckbox) {
    return (
      <th
        className="flex-1 p-4"
        style={{
          minWidth: `${minWidth}px`,
          flex: weight,
        }}
      >
        <div className="flex items-start justify-center">
          <Checkbox
            checked={isChecked}
            disabled={isDisabled}
            onChange={onCheckboxChange ?? noop}
          />
        </div>
      </th>
    );
  }

  return (
    <th
      className={`flex min-h-full flex-1 px-4 text-sm ${
        isCut ? "font-bold text-gray-900" : "font-medium text-gray-500"
      } ${
        sortFunction && hasSorting ? "cursor-pointer hover:bg-gray-100" : ""
      } ${
        align === "left"
          ? "justify-start"
          : align === "right"
            ? "justify-end"
            : "justify-center"
      }`}
      style={{
        minWidth: `${minWidth}px`,
        flex: weight,
      }}
      onClick={sortFunction && hasSorting ? handleOrderBy : undefined}
    >
      <span
        className={`flex w-fit flex-row items-center gap-2 ${
          sortFunction &&
          hasSorting &&
          location.search.includes(`order=${usableSortKeyName}`)
            ? "text-gray-900"
            : ""
        }`}
      >
        {title}
        {sortFunction && hasSorting && (
          <>
            {location.search.includes(`order=${usableSortKeyName}`) ? (
              <>
                {location.search.includes("orderBy=ASC") ? (
                  <ChevronUp
                    width={16}
                    height={16}
                    className="cursor-pointer"
                  />
                ) : (
                  <ChevronDown
                    width={16}
                    height={16}
                    className="cursor-pointer"
                  />
                )}
              </>
            ) : (
              <ArrowUpDown
                width={16}
                height={16}
                className="cursor-pointer"
              />
            )}
          </>
        )}
      </span>
    </th>
  );
};
